module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10030.251415c2.jpg";